import { Injectable, Inject } from '@angular/core';
import { OAuthService, AuthConfig, OAuthEvent } from 'angular-oauth2-oidc';
import { JwksValidationHandler, NullValidationHandler } from 'angular-oauth2-oidc';
import { filter, delay } from 'rxjs/operators';
import { AppSettingsService } from '../app-settings/app-settings.service';
import { AppSettings } from '../../entities/AppSettings';
import { appSettings } from '../../modules/shared/components/appSettings';
import { authConfig } from '../../modules/shared/components/auth/auth.config';
import { IPermissionConfig } from '@framework/app';
import { Permissions } from '../../config/AppEnums';
import { ApiService } from '@services/api/api.service';
import { BehaviorSubject, Subject, from } from 'rxjs';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { Router } from '@angular/router';
import { SignalRService } from '../signalr/signal-rservice.service';
import { PermissionRights } from '../../framework/core/Enums';
import { TdDialogService } from '@covalent/core/dialogs';
import { PasswordExpiredComponent } from '../../modules/shared/components/password-expired/password-expired.component';
import { InputValidationService } from '../input-validation/input-validation.service';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { ILookupSelectItem } from '../../common/formbuilder/FormBuilderControl';
import { ControlLookupCacheService } from '../control-lookup-cache/control-lookup-cache.service';
import * as ExtendedSettings from '../../common/application/models/ApplicationObjectExtendedSettingDTO';
import { MfControlPopupComponent } from '../../framework/components/mf-control-popup/mf-control-popup.component';
const STORAGE_KEY = 'currentOrganisationId';
const STORAGE_PROJECT_KEY = 'currentProjectId';
const STORAGE_KEY_REDIRECT = 'redirectUrl';

@Injectable({
  providedIn: 'root'
})
export class IdentityAuthService {
  currentRouteUrl: any;
  userProfile: any;
  loadingUser: boolean = false;
  discoveryDocumentLoaded: boolean = false;
  private _appSettingsLoaded: boolean = false;
  private _appConfigLoaded: boolean = false;
  public authenticating: boolean = false;
  public loadingAppSettings: boolean = true;
  public loadingAppConfig: boolean = true;
  public appSettingsLoadedEvent = new BehaviorSubject<boolean>(null);
  public appConfigLoadedEvent = new BehaviorSubject<boolean>(null);
  public currentProjectIdObserver = new BehaviorSubject(null);
  public userProjectsObserver = new BehaviorSubject(null);
  public currentOrgFriendlyName: string;
  public currentOrganisationIdObserver = new BehaviorSubject(null);
  public userOrganisationsObserver = new BehaviorSubject(null);
  public permissionsChangedObserver = new BehaviorSubject(null);
  public userProfileObserver = new BehaviorSubject(null);
  public onMainMenuChange = new BehaviorSubject(null);

  public wacomKey: string;
  public roleQuestionnaireGroups: any;
  private _mainMenuOpen: boolean = true;
  public get mainMenuOpen() { return this._mainMenuOpen }
  public set mainMenuOpen(val) { this._mainMenuOpen = val; this.onMainMenuChange.next(val); }
  private _currentOrganisationId = '';
  public get currentOrganisation() {
    var filt = this.userOrganisations.filter(o => o.id == this.currentOrganisationId);

    if (filt.length > 0)
      return filt[0];
  };
  public getOrg(orgId) {
    var filt = this.userOrganisationsOptions.filter(o => o.value == orgId);

    if (filt.length > 0)
      return filt[0];
  }
  public get currentOrganisationId() { return this._currentOrganisationId };
  public set currentOrganisationId(value) {
    var loaded = false;
    this.storage.set(STORAGE_KEY, value);
    if (value == this._currentOrganisationId)
      return;

    if (this._currentOrganisationId) {
      var _th = this;
      // this.router.navigateByUrl('/');
      this.loadingAppSettings = true;
      setTimeout(() => {
        _th._document.defaultView.location.reload();
      }, 1)
      return;
    }

    if (value) {
      this._currentOrganisationId = value;
      var friendly = this.userOrganisations.filter(o => o.id == value);
      if (friendly.length > 0) {
        this.currentOrgFriendlyName = friendly[0].name;
        this.titleService.setTitle(this.currentOrgFriendlyName);
        //this.document.getElementById('appFavicon').setAttribute('href', '/your/icon/path.ico');
        loaded = true;

        this.setOrgSpecficUrls();
      }
      else {
        this.loadOrgSettings();

      }
    }


    this._currentOrganisationId = value;
    if (loaded) {
      this.setOrg()
    }
  }
  private _currentProjectId = '';
  public get currentProjectId() { return this._currentProjectId };
  public set currentProjectId(value) {

    if (value == this._currentProjectId)
      return;
    this._currentProjectId = value;
    this.permissionsChangedObserver.next(null);
    this.currentProjectIdObserver.next(value);
    this.storage.set(STORAGE_PROJECT_KEY, value);
    this.controlLookupCacheService.clear();
  }
  private _appSettings: any;
  private _appConfig: IConfig;
  private _objectConfigs: any = {};
  public ovmPermissionCollections: any;
  public get AppSettingsLoaded(): boolean { return this._appSettingsLoaded; }
  public get AppConfigLoaded(): boolean { return this._appConfigLoaded; }
  public get AppConfig(): IConfig { return this._appConfig; }
  private mainConfigTask = null;
  constructor(private oauthService: OAuthService,
    private appSettingsService: AppSettingsService,
    private apiService: ApiService,
    public router: Router,
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    private signalRService: SignalRService,
    public dialogService?: TdDialogService,
    public inputValidationService?: InputValidationService,
    private titleService?: Title,
    @Inject(DOCUMENT) private document?: HTMLDocument,
    private controlLookupCacheService?: ControlLookupCacheService,
    @Inject(DOCUMENT) private _document?: Document) {
    this.mainConfigTask = this.configureWithNewConfigApi();
    this.apiService.authService = this;

    this.currentOrganisationId = this.storage.get(STORAGE_KEY) || '';
    this.currentProjectId = this.storage.get(STORAGE_PROJECT_KEY) || '';
    if (this.access_token)
      this.loadingUser = true;
  }

  get access_token() {
    if (this.discoveryDocumentLoaded)
      return this.oauthService.getAccessToken();
    else return false;
  }
  public setOrg() {
    this.permissionsChangedObserver.next(null);
    this.currentOrganisationIdObserver.next(this._currentOrganisationId);
    this.controlLookupCacheService.clear();
  }
  public async loadOrgSettings() {
    //this.loadingAppSettings = true;
    //if (!this.access_token) return;
    //this.apiService.get('/api/organisation/settings/' + this.currentOrganisationId)
    //  .subscribe(o => {
    //    if (o) {
    //      this.userOrganisations = [o];
    //      this.setOrgSpecficUrls();
    //      this.setOrg()
    //      this.currentOrgFriendlyName = this.userOrganisations[0].name;
    //      this.titleService.setTitle(this.currentOrgFriendlyName);
    //      this.loadingAppSettings = false;
    //    }
    //  })
  }
  public async loadOvmPermissions() {
    if (this.taskAppConfigOvm != null) {
      await this.taskAppConfigOvm;
    }
    else {
      this.taskAppConfigOvm = this.apiService.get('/api/organisation/getGrantedUserPermissions', null, appSettings.ovmApiServiceAddress).toPromise();
      var data = await this.taskAppConfigOvm;
      var orgPermissions = data[0];
      orgPermissions.permissionCollections.forEach(permission => {
        orgPermissions[permission.name] = permission.permissionCollectionID;
      });
      this.ovmPermissions = orgPermissions;
    }
  }
  private async configureWithNewConfigApi() {
    this.oauthService.tokenValidationHandler = new NullValidationHandler();
    this.oauthService.setStorage(sessionStorage);
    this.oauthService.setupAutomaticSilentRefresh();

    this.oauthService.events
      .pipe(filter(e => e.type === 'session_terminated'))
      .subscribe(e => {
        this.logoff();
      });
    this.oauthService.events
      .pipe(filter(e => e.type === 'invalid_nonce_in_state'))
      .subscribe(e => {
        alert('Invalid state, press ok to retry')
        this.login();
      });
    this.oauthService.events
      .pipe(filter(e => e.type === 'token_validation_error'))
      .subscribe(e => {
        this.login();
      });
    this.appSettingsService.getInputValidations().subscribe(data => {
      var patterns = this.inputValidationService.patterns = {};
      var flags = ['', 'i'],
        errorConditionTypes = ['required', 'pattern', 'maxLength', 'format'];
      data.InputValidatorList.forEach(inputValidator => {
        var pattern: IPattern = {
          regex: inputValidator.Regex,
          caption: inputValidator.Message
        }
        if (inputValidator.Placeholder) pattern.placeholder = inputValidator.Placeholder;
        if (inputValidator.OptionFlags) pattern.flags = flags[inputValidator.OptionFlags];
        if (inputValidator.MaxLength) pattern.maxLength = inputValidator.MaxLength;
        if (inputValidator.ErrorConditionList && inputValidator.ErrorConditionList.length > 0) {
          pattern.ErrorConditions = {};
          inputValidator.ErrorConditionList.forEach(o => {
            var errorCondition: IErrorConditions = <IErrorConditions>o;
            var patternErrorCondition: any = pattern.ErrorConditions[errorConditionTypes[errorCondition.Type]] = {};
            patternErrorCondition.description = errorCondition.Description;
            patternErrorCondition.message = errorCondition.Message;
            if (errorCondition.Regex) patternErrorCondition.regex = errorCondition.Regex;
          })
        }
        patterns[inputValidator.Name] = pattern;
      })
    }, err => {
    })

    if (this.taskAppSettings != null) {
      await this.taskAppSettings;

      this.taskAppSettings = null;
    }
    else {
      this.taskAppSettings = this.appSettingsService.getConfig().toPromise();
      var appSettingsReturn = await this.taskAppSettings;
      this.taskAppSettings = null;
      var identityOptions = appSettingsReturn['identityOptions'];
      appSettings.authority = identityOptions['authority'];
      appSettings.client_id = identityOptions['client_id'];
      appSettings.scope = identityOptions['scope'];
      appSettings.apiServiceAddress = identityOptions['apiServiceAddress'];
      appSettings.primaryUrl = identityOptions['primaryUrl'];
      appSettings.secondaryUrl = identityOptions['secondaryUrl'];
      authConfig.issuer = identityOptions['authority'];
      authConfig.clientId = identityOptions['client_id'];
      authConfig.scope += identityOptions['scope'];

      this.oauthService.configure(authConfig);

      var self = this;
      this.authenticating = true;
      this.taskDiscoveryDocumentLoaded = this.oauthService.loadDiscoveryDocumentAndTryLogin();
      try {
        var up = await this.taskDiscoveryDocumentLoaded;
      } catch {

        this.authenticating = false;
        this.loadingAppSettings = false;
        let dialogRef = this.dialogService.open(MfControlPopupComponent, {
          data: {
            title: 'Something went wrong', description: "Please click on retry to reload the page"
            , actions: ['Retry']
            , width: '50%'
            , disableClose: true
          },
        });
        dialogRef.afterClosed().subscribe(result => {
          window.location.reload();
        });
        return;
      }
      this.discoveryDocumentLoaded = true;
      this.authenticating = false;

      if (this.oauthService.hasValidAccessToken())
        this.loadUserProfile();
      else if (this.access_token) {

        this.authenticating = true;
        console.log('refresh')
        var _th = this;
        try {
          var info = await this.oauthService.silentRefresh();
          this.authenticating = false;
          console.log('silent refresh complete');
          _th.loadUserProfile();
        } catch (err) {
          console.error('refresh error', err);
          _th.login();
        }
      } else {
        this.authenticating = true;
        self.login();
      }


    }
  }

  public isAuthenticated(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  public login() {
    console.log('login')
    this.oauthService.initImplicitFlow();
  }

  public logoff() {
    this.oauthService.logOut();
  }
  public triggerIfUserIsLoaded() {
    if (this.userProfile)
      this.userProfileObserver.next(this.userProfile);
  }
  private taskAppSettings = null;
  private taskAppConfig = null;
  private taskAppConfigOvm = null;
  private taskDiscoveryDocumentLoaded = null;
  public async ensureAppSettingsLoaded() {
    if (this.mainConfigTask != null)
      await this.mainConfigTask;
    if (!this._appConfig) {
      if (this.taskAppConfig == null) {
        this.taskAppConfig = this.apiService.get('/api/config', null).toPromise();
      }
      var config = null;
      try {
        config = await this.taskAppConfig;
      } catch (err) {
        if (err.status != 401) {
          console.error('api config error', err);
          this.authenticating = false;
          this.loadingAppSettings = false;
          let dialogRef = this.dialogService.open(MfControlPopupComponent, {
            data: {
              title: 'Something went wrong', description: "Please click on retry to reload the page"
              , actions: ['Retry']
              , width: '50%'
              , disableClose: true
            },
          });
          dialogRef.afterClosed().subscribe(result => {
            window.location.reload();
          });
        }

        else this.authenticating = true;

      }
      appSettings.currencies = config.currencies;
      appSettings.currencies.forEach(o => {
        o.symbol += ' ';
      })
      this.taskAppConfig = null;
      this.loadingAppConfig = false;
      this._appConfig = config;
      this.wacomKey = config.wacomKey;
      this.permissions = config.permissions;
      this.roleQuestionnaireGroups = config.roleQuestionnaireGroups;
      this.userOrganisations = config.organisations;// config.projects;
      if (this.userOrganisations) {
        this._userOrganisationsOptions = this.userOrganisations.map(item => {
          return { label: item.name, value: item.id }
        })
        this.userOrganisations.forEach(org => {
          this.userOrganisations[org.id.toUpperCase()] = org.name;
        });
      }

      if (this.currentOrganisationId == '' || this.userOrganisationsOptions.filter(o => o.value == this.currentOrganisationId).length == 0)
        this.currentOrganisationId = this.userOrganisationsOptions.length > 0 ? this.userOrganisationsOptions[0].value : '';

      //if (this.currentOrganisation) {
      //  var app = this.currentOrganisation.apps.filter(o => o.id.toLowerCase() == '3B2CEEDD-0059-4D5F-A750-8B6586CD5478'.toLowerCase());
      //  if (app.length > 0) {
      //    appSettings.apiServiceAddress = app[0].appInstance.apiAddress;
      //  }
      //}
      //else if (this.userOrganisationsOptions.filter(o => o.value == this.currentOrganisationId).length == 0)
      //this.currentOrganisationId = this.userOrganisationsOptions.length > 0 ? this.userOrganisationsOptions[0].value : '';

      if (this.currentOrganisationId) {
        var friendly = this.userOrganisationsOptions.filter(o => o.value == this.currentOrganisationId);
        if (friendly.length > 0) {
          this.currentOrgFriendlyName = friendly[0].label;
          this.titleService.setTitle(this.currentOrgFriendlyName);
          appSettings.functionalCurrency = this.currentOrganisation?.functionalCurrency ?? { symbol: 'R' };
          //console.log("appSettings.functionalCurrency:", appSettings.functionalCurrency);
          appSettings.currentCurrency.symbol += ' ';
          //console.log("appSettings.currentCurrency.symbol:", appSettings.currentCurrency.symbol);
          /*appSettings.currentCurrency.symbol = 'FC ';
          console.log("appSettings.currentCurrency.symbol:", appSettings.currentCurrency.symbol);*/
          //this.document.getElementById('appFavicon').setAttribute('href', '/your/icon/path.ico');
        }
        else await this.loadOrgSettings();
      }
      this.userProjects = config.projects;
      if (this.userProjects) {
        this.setProjects();
        this.currentOrganisationIdObserver.subscribe(i => { this.setProjects() });
        this.userProjects.forEach(proj => { this.userProjects[proj.id.toUpperCase()] = proj.name });
      }
      if (config.excludedObjects) {
        this._objectConfigs = config.excludedObjects;
        this._objectConfigs.forEach(obj => {
          let excludedObjectField: IObjectConfig = <IObjectConfig><unknown>obj;
          let parent: string = null;
          if (excludedObjectField.parentName) {
            parent = excludedObjectField.parentName.toLowerCase();
          }
          else {
            parent = excludedObjectField.name.toLowerCase();
          }
          if (!this._objectConfigs[parent]) this._objectConfigs[parent] = new Array<IObjectConfig>();
          this._objectConfigs[parent].push(excludedObjectField);
          let fieldName: string = excludedObjectField.name ? excludedObjectField.name.toLowerCase() : parent;
          if (!this._objectConfigs[parent][fieldName]) this._objectConfigs[parent][fieldName] = new Array<IObjectConfig>();
          this._objectConfigs[parent][fieldName].push(excludedObjectField);
        })
      }
      this._appConfigLoaded = true;
      this.appConfigLoadedEvent.next(true);

      //if (config.passwordExpiryStatus == 1 || config.passwordExpiryStatus == 2) {
      //  const ref = this.dialogService.open(PasswordExpiredComponent, {
      //    data: {

      //    },
      //    width: '50%',
      //    disableClose: true,
      //    hasBackdrop: true
      //  }); 
      //}
      this.loadingAppSettings = false;

      //}
    }
    //debugger;
    if (this.taskAppConfigOvm != null)
      await this.taskAppConfigOvm;

    return;
  }
  public setOrgSpecficUrls() {
    //if (this.currentOrganisation) {
    //  var app = this.currentOrganisation.apps.filter(o => o.id.toLowerCase() == '3B2CEEDD-0059-4D5F-A750-8B6586CD5478'.toLowerCase());
    //  if (app.length > 0) {
    //    appSettings.ovmApiServiceAddress = app[0].appInstance.apiAddress;

    //  }
    //}
  }
  loadUserProfile() {
    var _th = this;
    var redirectUrl = this.storage.get(STORAGE_KEY_REDIRECT) || '';
    this.signalRService.createConnection();
    this.loadingUser = true;
    this.oauthService.loadUserProfile().then(up => {

      if (Object.prototype.toString.call((<any>up).name) === '[object Array]')
        (<any>up).name = (<any>up).name[0];
      _th.userProfile = up;
      _th.loadingUser = false;
      // _th.userProfileObserver.next(up);

      if (redirectUrl != '') {
        if (_th.router.url != redirectUrl)
          _th.router.navigateByUrl(redirectUrl);
        _th.storage.set(STORAGE_KEY_REDIRECT, '');
      }
    });

    this.ensureAppSettingsLoaded();
  }

  private setProjects() {
    return;
    //let organisation = this.userOrganisations.find(uo => uo.id == this.currentOrganisationId);
    //if (organisation && organisation.projects) this._userProjectsOptions = this.userProjects.filter(up => { return organisation.projects.findIndex(p => p == up.id) > -1 }).map(item => {
    //  return { label: item.name, value: item.id }
    //})
    //if (this.currentProjectId == '') this.currentProjectId = this.userProjectsOptions.length > 0 ? this.userProjectsOptions[0].value : '';
    //else if (this.userProjectsOptions.filter(o => o.value == this.currentProjectId).length == 0) this.currentProjectId = this.userProjectsOptions.length > 0 ? this.userProjectsOptions[0].value : '';
  }

  private _userOrganisationsOptions: ILookupSelectItem[] = [];
  public get userOrganisationsOptions() {
    return this._userOrganisationsOptions
  }

  private _userProjectsOptions: ILookupSelectItem[] = [];
  public get userProjectsOptions() {
    return this._userProjectsOptions
  }

  public Permissions = Permissions;
  public PermissionRights = PermissionRights;

  private _userOrganisations: Array<IUserOrganisations> = [];
  public get userOrganisations() {
    return this._userOrganisations
  }
  public set userOrganisations(value) {
    this._userOrganisations = value;
    this.userOrganisationsObserver.next(value);

    this.permissionsChangedObserver.next(null);
  }

  private _userProjects: Array<IUserProjects> = [];
  public get userProjects() {
    return this._userProjects
  }
  public set userProjects(value) {
    this._userProjects = value;
    this.userProjectsObserver.next(value);

    this.permissionsChangedObserver.next(null);
  }
  public ovmPermissions: any;
  public ovmPermissionGuid(permission) {
    if (!this.ovmPermissions || !this.ovmPermissions[permission]) return;
    return this.ovmPermissions[permission];
  }
  public hasOvmPermission(...permissions: Array<any>) {
    var accessGranted = false;
    if (this.ovmPermissions) {
      permissions.forEach(o => {
        if (this.ovmPermissions[o])
          accessGranted = true;
        else accessGranted = false;
      })
    };
    return accessGranted;
  }
  public hasAnyOvmPermission(...permissions: Array<any>) {
    var accessGranted = false;
    if (this.ovmPermissions) {
      permissions.forEach(o => {
        if (this.ovmPermissions[o])
          accessGranted = true;
      })
    };
    return accessGranted;
  }
  public hasSiteAccess(siteId) {
    if (!this.ovmPermissions || !this.ovmPermissions.sites) return false;
    return this.ovmPermissions.sites.filter(function (s) { return s == siteId }).length > 0;
  }
  public hasScanAccess(scanId) {
    if (!this.ovmPermissions || !this.ovmPermissions.scans) return false;
    return this.ovmPermissions.scans.filter(function (s) { return s == scanId }).length > 0;
  }
  public permissions: Array<Permissions> = [Permissions.SuperAdmin]; //TODO populate with call to api
  public hasPermissions(...requiredPermissions: Array<Permissions>): boolean {
    if (!this.userOrganisations || this.userOrganisations.length == 0)
      return false;
    var filteredOrgs = this.userOrganisations.filter(o => {
      return o.id == this.currentOrganisationId
    });
    if (filteredOrgs.length == 0)
      return false;
    var filteredOrg = filteredOrgs[0];
    if (filteredOrg.permissions.indexOf(Permissions.SuperAdmin) != -1 || filteredOrg.permissions.indexOf(Permissions.Admin) != -1)
      return true;
    var returnVal = true;
    if (requiredPermissions.length == 0)
      return false;
    requiredPermissions.forEach(perm => {
      if (filteredOrg.permissions.indexOf(perm) == -1)
        returnVal = false;
    });
    return returnVal;
  }
  public canViewField(objectName: string, fieldName: string): boolean {
    return true;
  };
  public hasAnyPermissionsDeprecated(permission: Permissions): boolean {

    return this.hasAnyPermissionsArr([{ permissions: [{ permission: permission, rights: PermissionRights.None }] }]);
  }
  public hasAnyPermissionsMultDeprecated(...permission: Array<Permissions>): boolean {

    return this.hasAnyPermissionsArrDeprecated(permission);
  }

  public hasAnyPermissionsArrDeprecated(permissions: Array<Permissions>): boolean {
    var arr = new Array();
    permissions.forEach(o => {
      arr.push({ permissions: [{ permission: o, rights: PermissionRights.None }] })
    })
    return this.hasAnyPermissionsArr(arr);
  }
  public get userId(): string {
    if (this.userProfile && this.userProfile.sub) return this.userProfile.sub;

  }
  public hasAnyPermissionsArr(requiredPermissions: Array<IPermissionConfig>): boolean {
    //var test = PermissionRights.Create | PermissionRights.Delete | PermissionRights.Read | PermissionRights.Update | PermissionRights.Selectable;
    //var test2 = PermissionRights.Create === ( test & PermissionRights.Create);
    //var test3 = PermissionRights.Create === (test & PermissionRights.Create);
    //var test4 = PermissionRights.Read === (test & PermissionRights.Read);

    if (!this.userOrganisations || this.userOrganisations.length == 0) return false;
    var filteredOrgs = this.userOrganisations.filter(o => { return o.id == this.currentOrganisationId });
    if (filteredOrgs.length == 0) return false;
    var filteredOrg = filteredOrgs[0];
    if (!filteredOrg.permissionsWithRights) return false;
    // if (filteredOrg.permissions.indexOf(Permissions.SuperAdmin) != -1 || filteredOrg.permissions.indexOf(Permissions.Admin) != -1) return true;
    var returnVal = false;
    if (requiredPermissions.length == 0) return true;

    requiredPermissions.forEach(conf => {
      var hasAll = true;
      if (!conf.permissions)
        console.dir('incorrect permission format')
      conf.permissions.forEach(perm => {
        var hasPermission = filteredOrg.permissionsWithRights.filter(np => {
          return np.permission == perm.permission && (!perm.rights || perm.rights === (np.rights & perm.rights))
        });

        if (hasPermission.length == 0)
          hasAll = false;
      });
      if (hasAll)
        returnVal = true;
    });
    return returnVal;
  }
  public hasAnyPermissions(...requiredPermissions: Array<IPermissionConfig>): boolean {
    return this.hasAnyPermissionsArr(requiredPermissions);
  }
  public hasQuestionnaireRights(questionnaireGroupId, rights: PermissionRights) {
    if (!this.roleQuestionnaireGroups)
      return false;
    var groups = this.roleQuestionnaireGroups.filter(o => {
      return o.questionnaireGroupId == questionnaireGroupId
    });
    var result = false;
    if (groups.length > 0) {
      groups.forEach(group => {
        if (rights === (group.rights & rights))
          result = true;
      })

    }
    return result;
  }
  public fieldLabelName(objectName: string, fieldName: string): string {
    if (!objectName) return null;
    if (!fieldName) fieldName = objectName;
    //if (fieldName.toLowerCase() == "publicidentifier") debugger;
    //console.info([objectName, fieldName]);
    let fields: Array<IObjectConfig> = this._objectConfigs[objectName.toLowerCase()] ? this._objectConfigs[objectName.toLowerCase()][fieldName.toLowerCase()] : null;
    if (!fields || fields.length == 0) return null;
    let fieldLabel: string = null,
      level: number = 0;
    fields = fields.filter(f => f.labelName != null && f.labelName != undefined);
    if (!fields || fields.length == 0) return null;
    fields.forEach(field => {
      if (field.appId) {
        if (level < 4 && field.appId.toLowerCase() == this.currentProjectId.toLowerCase()) {
          if (field.organisationId) {
            if (level < 5 && this._userOrganisations[field.organisationId.toUpperCase()]) { fieldLabel = field.labelName; level = 5 }
          }
          else if (level < 4) { fieldLabel = field.labelName; level = 4 }
        }
        else if (level < 2 && field.appId.toLowerCase() == this._appConfig.appId.toLowerCase()) {
          if (field.organisationId) {
            if (level < 3 && this._userOrganisations[field.organisationId.toUpperCase()]) { fieldLabel = field.labelName; level = 3 }
          }
          else if (level < 2) { fieldLabel = field.labelName; level = 2 }
        }
      }
      else if (level == 0 && field.organisationId && field.organisationId.toLowerCase() == this.currentOrganisationId.toLowerCase()) { fieldLabel = field.labelName; level = 1 };
/*
      if (field.appId && (field.appId.toLowerCase() == this._appConfig.appId.toLowerCase() || field.appId.toLowerCase() == this.currentProjectId.toLowerCase())) {
        if (field.organisationId) {
          if (this._userOrganisations[field.organisationId.toUpperCase()]) fieldLabel = field.labelName;
        }
        else {
          fieldLabel = field.labelName;
        }
      }
      else if (!field.appId && field.organisationId && field.organisationId.toLowerCase() == this.currentOrganisationId.toLowerCase()) fieldLabel = field.labelName;
*/    });
    //console.info([objectName, fieldName, fieldLabel]);
    return fieldLabel;
  };
  public fieldGroupName(objectName: string, fieldName: string): string {
    if (!objectName) return null;
    if (!fieldName) fieldName = objectName;
    let fields: Array<IObjectConfig> = this._objectConfigs[objectName.toLowerCase()] ? this._objectConfigs[objectName.toLowerCase()][fieldName.toLowerCase()] : null;
    if (!fields || fields.length == 0) return null;
    let groupName: string = null,
      level: number = 0;
    fields = fields.filter(f => f.groupName != null && f.groupName != undefined);
    if (!fields || fields.length == 0) return null;
    fields.forEach(field => {
      if (field.appId) {
        if (level < 4 && field.appId.toLowerCase() == this.currentProjectId.toLowerCase()) {
          if (field.organisationId) {
            if (level < 5 && this._userOrganisations[field.organisationId.toUpperCase()]) { groupName = field.groupName; level = 5 }
          }
          else if (level < 4) { groupName = field.groupName; level = 4 }
        }
        else if (level < 2 && field.appId.toLowerCase() == this._appConfig.appId.toLowerCase()) {
          if (field.organisationId) {
            if (level < 3 && this._userOrganisations[field.organisationId.toUpperCase()]) { groupName = field.groupName; level = 3 }
          }
          else if (level < 2) { groupName = field.groupName; level = 2 }
        }
      }
      else if (level == 0 && field.organisationId && field.organisationId.toLowerCase() == this.currentOrganisationId.toLowerCase()) { groupName = field.groupName; level = 1 };
/*      if (field.appId && (field.appId.toLowerCase() == this._appConfig.appId.toLowerCase() || field.appId.toLowerCase() == this.currentProjectId.toLowerCase())) {
        if (field.organisationId) {
          if (this._userOrganisations[field.organisationId.toUpperCase()]) groupName = field.groupName;
        }
        else {
          groupName = field.groupName;
        }
      }
      else if (field.organisationId && field.organisationId.toLowerCase() == this.currentOrganisationId.toLowerCase()) groupName = field.groupName;
*/    });
    //console.info([objectName, fieldName, fieldLabel]);
    return groupName;
  };
  public extendedSettings(objectName: string, fieldName: string): Array<ExtendedSettings.IApplicationObjectExtendedSettingFields> {
    let extendedSettings: Array<ExtendedSettings.IApplicationObjectExtendedSettingFields> = new Array<ExtendedSettings.IApplicationObjectExtendedSettingFields>();
    if (!objectName) return extendedSettings;
    if (!fieldName) fieldName = objectName;
    let fields: Array<IObjectConfig> = this._objectConfigs[objectName.toLowerCase()] ? this._objectConfigs[objectName.toLowerCase()][fieldName.toLowerCase()] : null;
    if (!fields || fields.length == 0) return extendedSettings;
    let level: number = 0;
    fields = fields.filter(f => f.extendedSettings != null && f.extendedSettings != undefined);
    if (!fields || fields.length == 0) return extendedSettings;

    fields.forEach(field => {
      if (field.appId) {
        if (level < 4 && field.appId.toLowerCase() == this.currentProjectId.toLowerCase()) {
          if (field.organisationId) {
            if (level < 5 && this._userOrganisations[field.organisationId.toUpperCase()]) { extendedSettings = field.extendedSettings; level = 5 }
          }
          else if (level < 4) { extendedSettings = field.extendedSettings; level = 4 }
        }
        else if (level < 2 && field.appId.toLowerCase() == this._appConfig.appId.toLowerCase()) {
          if (field.organisationId) {
            if (level < 3 && this._userOrganisations[field.organisationId.toUpperCase()]) { extendedSettings = field.extendedSettings; level = 3 }
          }
          else if (level < 2) { extendedSettings = field.extendedSettings; level = 2 }
        }
      }
      else if (level == 0 && field.organisationId && field.organisationId.toLowerCase() == this.currentOrganisationId.toLowerCase()) { extendedSettings = field.extendedSettings; level = 1 };
    });
    return extendedSettings ? extendedSettings : new Array<ExtendedSettings.IApplicationObjectExtendedSettingFields>();
  };
}

enum PasswordExpiryStatus {
  Ok,
  Expired,
  ResetRequired,
  Error
}
export interface IObjectConfig {
  id: string;
  name: string;
  description?: string;
  parentId?: string;
  parentName?: string;
  appId?: string;
  organisationId?: string;
  roleId?: string;
  excluded: boolean;
  labelName?: string;
  groupName?: string;
  extendedSettings?: any;
}
export interface IConfig {
  passwordExpiryStatus: PasswordExpiryStatus;
  hasLocalPasswordSet: boolean;
  changePasswordEndpoint: string;
  defaultLandingPage: string;
  passwordExpiryDays: number;
  isSuperAdmin: boolean;
  permissions: string[];
  objectConfigs: Array<IObjectConfig>;
  organisations: Array<any>;
  requiredPermissions: string[];
  skinName?: string;
  themeName?: string;
  appName?: string;
  appId?: string;
}
export interface IUserProjects {
  id: any,
  name: any
}
export interface IUserOrganisations {
  id: any,
  name: any,
  description: any,
  permissions: Array<Permissions>,
  permissionsWithRights: Array<IPermissionWithRights>,
  projects: Array<IUserProjects>,
  functionalCurrency: any;
}

export interface IApp {
  id: any;
  appInstance: IAppInstance
}export interface IAppInstance {
  id: any;
  apiAddress: any
}
export interface IErrorConditions {
  Type: string;

  Description: string;
  Message: string;
  Regex: any;
}
export interface IPattern {
  regex: any;
  caption: string;
  placeholder?: string;
  flags?: string;
  maxLength?: number;
  ErrorConditions?: any;
}
export interface IPermissionWithRights {
  permission: Permissions,
  rights: PermissionRights
}
